import React, {useState} from "react";
import {Icon} from '@iconify/react';
import incognitoIcon from '@iconify/icons-mdi/incognito-circle';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Redirect } from "react-router-dom";
import PopUp from './PopUp';
import Footer from './Footer';

const themeDark = createMuiTheme({
    palette: {
        background: {
            default: "#202124"
          },
        primary: {
            main: '#282C2F',
          },
          secondary: {
            main: '#D6D6D7',
          },
    }
})

const useStyles = makeStyles((theme) => ({
      paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: theme.spacing(5),
        paddingBottom: theme.spacing(6),
      },
      icon: {
        margin: theme.spacing(1),
        width: 70,
        height: 70,
      },
      form: {
        width: '100%', 
        marginTop: theme.spacing(1),
      },
      submit: {
        margin: theme.spacing(3, 0, 1),
      },
}));

function Login() {
    
    const classes = useStyles();
    const [token, setToken] = useState('Ex. 123456789');
    const [name, setName] = useState('');
    const [key, setKey] = useState('');
    const [errorTextName, setErrorTextName] = useState('');
    const [errorName, setErrorName] = useState(false);
    const [errorTextToken, setErrorTextToken] = useState('');
    const [errorToken, setErrorToken] = useState(false);
    const [canSubmit, setCanSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false);

    const checkInput = async (evt) => {

      var submit = true;

      setErrorName(false);
      setErrorToken(false);
      setErrorTextName('');
      setErrorTextToken('');

      const url = "https://project-anonymous-boris.herokuapp.com/validateInput";
      // const url = "http://localhost:5000/validateInput";
      evt.preventDefault();

      if(name === ""){
        submit = false;
        setErrorTextName('Username cannot be empty.');
        setErrorName(true);
      }
      if(key === ""){
        submit = false;
        setErrorTextToken('Access token cannot be empty.');
        setErrorToken(true);
      }

      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: name,
          token: key,
        })
      });

      const data = await response.json();
      if(!data.name && name !== ''){
        submit = false;
        setErrorTextName('Username already taken.');
        setErrorName(true);
      }
      if(!data.token && key !== ''){
        submit = false;
        setErrorTextToken('Invalid Access Token.');
        setErrorToken(true);
      }
      
      if(submit){
        setCanSubmit(true);
      }
    }

    const getToken = async () => {
      const url = "https://project-anonymous-boris.herokuapp.com/generate";
      // const url = 'http://localhost:5000/generate';
      setLoading(true);
      const response = await fetch(url);
      const data = await response.json();
      setToken(data.token);
      setLoading(false);
    }

    if(canSubmit){
      return <Redirect to={'/messages?name=' + name + '&token=' + key}/>;
    }

    return(
    <ThemeProvider theme = {themeDark}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Paper>
          <div className={classes.paper}>
            <Icon icon={incognitoIcon} className={classes.icon}/>
            <Typography component="h1" variant="h5">
              Project Anonymous
            </Typography>
            <Typography variant="caption">
              What You Say In Here Stays In Here
            </Typography>
            <form 
              className={classes.form} 
              noValidate 
              onSubmit={
                (evt)=>{evt.preventDefault()}
              }
            >
              <TextField
                error={errorName}
                helperText={errorTextName}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="Name"
                label="Username"
                type="text"
                id="Name"
                autoComplete="off"
                onChange={(evt)=>{setName(evt.target.value)}}
              />
              <TextField
                error={errorToken}
                helperText={errorTextToken}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="AccessTokenInput"
                label="Access Token"
                name="Access Token"
                autoComplete="off"
                type="password"
                onChange={(evt)=>{setKey(evt.target.value)}}
              />
              <Button
                type="submit"
                onClick={(evt)=>{
                  checkInput(evt);
                }}
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Enter
              </Button>
            </form>
            <Button
              onClick={getToken}
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              className={classes.submit}
            >
              Generate Access Token
            </Button>
            {loading? 
              <CircularProgress className={classes.submit}/>:
              <CopyToClipboard text={token !== 'Ex. 123456789'? token : ''}>
                <Button
                  variant="outlined"
                  className={classes.submit}
                  id="AccessTokenOutput"
                  onClick={()=>{
                    if(token !== 'Ex. 123456789'){
                      setShowPopUp(true);
                      setTimeout(()=>{setShowPopUp(false)}, 4000);
                    }
                  }}
                >
                  {token}
                </Button>
              </CopyToClipboard>
            } 
            {showPopUp? <PopUp type='login'/>: null}
          </div>
        </Paper>
        <Box mt={5}>
          <Footer />
        </Box>
      </Container>
    </ThemeProvider>
  );
}

export {Login, themeDark};
